import {
  startOfWeek,
  startOfMonth,
  endOfWeek,
  formatISO,
  endOfMonth,
  format,
} from 'date-fns';
import { START_OF_WEEK } from '../../../constents';

export default function Period({ periodFilter, setPeriodFilter }) {
  const isDay = periodFilter.name === 'day';
  const isWeek = periodFilter.name === 'week';
  const isMonth = periodFilter.name === 'month';

  const dateDispatch = (selectedPeriod, startDate, endDate) => {
    // Prevent unnecessary API requests if the same period and date are already selected
    if (
      periodFilter.name === selectedPeriod &&
      periodFilter.startDate &&
      format(new Date(periodFilter.startDate), 'yyyy-MM-dd') ===
        format(new Date(startDate), 'yyyy-MM-dd')
    ) {
      return;
    }

    setPeriodFilter({
      name: selectedPeriod,
      startDate,
      endDate,
    });
  };

  const handlePeriodClick = (selectedPeriod) => {
    // Use current date so that clicking Day/Week/Month jumps back to the current time
    const baseDate = new Date();

    if (selectedPeriod === 'day') {
      dateDispatch(selectedPeriod, formatISO(baseDate), formatISO(baseDate));
    } else if (selectedPeriod === 'week') {
      const startDate = formatISO(
        startOfWeek(baseDate, START_OF_WEEK),
      );
      const endDate = formatISO(
        endOfWeek(baseDate, START_OF_WEEK),
      );
      dateDispatch(selectedPeriod, startDate, endDate);
    } else if (selectedPeriod === 'month') {
      const startDate = formatISO(startOfMonth(baseDate));
      const endDate = formatISO(endOfMonth(baseDate));
      dateDispatch(selectedPeriod, startDate, endDate);
    }
  };

  return (
    <div className="appt-d-display-lbl">
      <span
        className={`d-sec ${isDay ? 'selected-cal' : ''}`}
        onClick={() => handlePeriodClick('day')}
      >
        Day
      </span>
      <span
        className={`d-sec ${isWeek ? 'selected-cal' : ''}`}
        onClick={() => handlePeriodClick('week')}
      >
        Week
      </span>
      <span
        className={`d-sec ${isMonth ? 'selected-cal' : ''}`}
        onClick={() => handlePeriodClick('month')}
      >
        Month
      </span>
    </div>
  );
}
